import {
  IconCircleCheck,
  IconCircleX,
  IconFlagCheck,
  IconX,
} from "@tabler/icons-react";

function PurchaseCompletionModal({
  purchase,
  loading = false,
  onClose,
  resolveName,
}) {
  const items = Array.isArray(purchase?.items) ? purchase.items : [];

  return (
    <div className="app-modal-overlay" role="presentation">
      <article
        className="app-modal cms-purchases-completion-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="purchase-completion-title"
      >
        <div className="app-modal-header cms-purchases-modal-head">
          <div>
            <p className="cms-purchases-kicker">Purchase items</p>
            <h3 id="purchase-completion-title">
              <IconFlagCheck size={20} />
              Completion
            </h3>
          </div>
          <button
            className="app-icon-btn app-icon-btn--back"
            type="button"
            onClick={onClose}
            aria-label="Close purchase completion"
            title="Close"
          >
            <IconX size={18} />
          </button>
        </div>

        <div className="app-modal-body cms-purchases-completion-body">
          {loading ? (
            <p className="cms-purchases-loading">Loading items...</p>
          ) : null}

          {purchase && !loading ? (
            <div className="cms-purchases-completion-list">
              {items.map((item) => {
                const isCompleted = item?.completed === true;

                return (
                  <article
                    key={item.id}
                    className="cms-purchases-completion-item"
                  >
                    <img
                      src={item.startPoint?.imageUrl || ""}
                      alt={resolveName(item.startPoint?.name)}
                      onError={(event) => {
                        event.currentTarget.style.display = "none";
                      }}
                    />
                    <div className="cms-purchases-completion-copy">
                      <strong>{resolveName(item.startPoint?.name)}</strong>
                      <span>
                        Tour: <b>{resolveName(item.tour?.name)}</b>
                      </span>
                    </div>
                    <span
                      className={`cms-purchases-completion-status ${
                        isCompleted ? "is-completed" : "is-pending"
                      }`}
                      title={isCompleted ? "Completed" : "Pending"}
                    >
                      {isCompleted ? (
                        <IconCircleCheck size={22} />
                      ) : (
                        <IconCircleX size={22} />
                      )}
                      {isCompleted ? "Completed" : "Pending"}
                    </span>
                  </article>
                );
              })}

              {!items.length ? (
                <p className="cms-purchases-muted">No items found.</p>
              ) : null}
            </div>
          ) : null}
        </div>
      </article>
    </div>
  );
}

export default PurchaseCompletionModal;
